import React from 'react';
import { IAddToComboButton } from '../../../../../models/try2Combo';
import styleClasses from '../../../try2.module.scss';

const AddToComboButton: React.FC<IAddToComboButton> = ({
  addToComboClickHandler,
  item,
}) => {

  const handleAddToComboClick = (e:any) => {
    e.stopPropagation() // changed by samran
    addToComboClickHandler(item)
  }

  return (
    <button
      type="button"
      onClick={(e) => handleAddToComboClick(e)}
      className={`${styleClasses.try2_item_order_btn} btn btn-large`}
      data-testid = "addToCombo"
    >
      add to combo
    </button>
  );
};

export default AddToComboButton;
